<div class="widget-area">
  <div class="widget-archives footer-widget mb-50">
    <h3 class="widget-title">Faculty</h3>
    <ul>
      <li class="menu-item-has-children" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
        <ul class="sub-menu">
          <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/faculty/departments">Departments</a></li>
          <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/faculty/teaching-and-nonteaching">Teaching &amp; Non Teaching</a></li>
          <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/faculty/profile">Profile</a></li>
          <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/faculty/publications">Publications</a></li>
          <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/faculty/research">Research</a></li>
          <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/faculty/achievements">Achievements</a></li>
          <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/faculty/any-others">Any Others</a></li>
        </ul>
      </li>
    </ul>
  </div>
</div>
